module.exports = {
    bindFunc: (obj, list) => {
        list.map(item => {
            obj[item] = obj[item].bind(obj);
        });
    },
    back: () => {
        window.history.go(-1);
    },
    invalidValue: (value) => {
        return value === undefined || value === null || ('' + value).trim() === '';
    },
    validPrice: value => {  //  onChange的时候校验输入价格的
        // if (value !== '' && !('' + value).match(/^(\d*)(\.\d*)?$/g)) {
        if (value !== '' && !('' + value).match(/^([1-9]\d*|0)?$/g)) {
            return false;
        }
        return true;
    },
    validNum: value => {//  onChange的时候校验输入数量的
        if (value !== '' && !('' + value).match(/^([1-9]\d*)?$/g)) {
            return false;
        }
        return true;
    },
    validNumber: value => {//  onChange的时候校验输入是否是数字的
        if (value !== '' && !('' + value).match(/^([0-9]\d*)?(\.\d*)?$/g)) {
            return false;
        }
        return true;
    },
    getTime: time => {
        if (typeof time === 'string') {
            let tmp = time.split(' ');
            let date = tmp[0].split('-');
            let min = tmp[1].split(':');
            return new Date(date[0], date[1] - 1, date[2], min[0], min[1], min[2]);
        } else {
            return new Date(time);
        }
    },
    countDown: time => {
        // let now = new Date().getTime();
        // let time = endTime - now;
        let day = Math.floor(time / 1000 / 60 / 60 / 24);
        let hour = Math.floor(time / 1000 / 60 / 60 % 24);
        let minute = Math.floor(time / 1000 / 60 % 60);
        let second = Math.floor(time / 1000 % 60);
        return {
            day: day >= 0 ? day : 0,
            hour: hour >= 0 ? hour : 0,
            minute: minute >= 0 ? minute : 0,
            second: second >= 0 ? second : 0
        };
    },
    formatDateTime: date => {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    getGdsNumErrorText: (code, min, max, times) => {
        let mapper = {
            1001: `该商品${min}件起售`,
            1002: `该商品最多可购买${max || 999999999}件`,
            1003: `该商品为组合销售，${times}件为一组`
        };
        return mapper[code] || '数量错误';
    }
};



// WEBPACK FOOTER //
// ./js/common/utils.js